module.exports = __webpack_public_path__ + "static/media/Info.fc4ee2c1.md";